import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render winners count section for FAQ Page
 */
const WinnersCountSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans leading-[1.4]"
      data-testid="winners-count-section-component"
    >
      <AccordionV2
        testId="winners-count"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="1. How many winners will there be, and what can each winner receive?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 py-4 pb-0">
          <p className="mt-1">
            <strong>Emerging Enterprise Award</strong>
          </p>

          <p>
            Recognises emerging enterprises that demonstrate an enterprising
            mindset. These are businesses that drive consistent, significant and
            sustainable growth, resulting in excellent business performance; and
            display the ability to scale and expand overseas.
          </p>

          <p className="mb-0">
            Winner(s) (or their newly-established subsidiary, partnership or
            sole proprietorship, where applicable) will each receive from:
          </p>

          <ul className="mb-4 list-outside list-disc pl-8">
            <li>
              OCBC Bank (or any of its subsidiaries in Malaysia, Indonesia
              and/or Hong Kong (collectively, &quot;OCBC Subsidiaries&quot; and
              each an &quot;OCBC Subsidiary&quot;) – a 2 year, interest-free
              term loan of up to SGD 200,000 (or MYR 600,000, or HKD 1,000,000,
              or IDR 2,000,000,000, as set out in the terms and conditions);
            </li>

            <li>
              The Business Times - Media publicity in print, digital, social
              media for Singapore and the region; and
            </li>

            <li>
              RSM - &quot;Consulting Package for Growing Businesses” worth
              SGD$15,000.
            </li>
          </ul>

          <p>
            <strong>Most Promising Startup Award</strong>
          </p>

          <p>
            Recognises emerging enterprises with a strong startup spirit. These
            are startups that have developed a unique and commercially viable
            idea, which has the potential to be sustained in the long run.
          </p>

          <p className="mb-0">Winner(s) will receive from:</p>

          <ul className="mb-15 list-outside list-disc pl-8">
            <li>
              The Business Times - Media publicity in print, digital, social
              media for Singapore and the region.
            </li>
          </ul>

          <p>
            <strong>Emerging Enterprise Sustainability Award</strong>
          </p>

          <p>
            Recognises emerging enterprises that are capitalising on growth
            opportunities in the green economy, embedding sustainability in
            their businesses and leveraging technology and new solutions to
            drive the change and transition to low-carbon businesses and
            industries.
          </p>

          <p className="mb-0">
            Winner(s) (or their newly-established subsidiary, partnership or
            sole proprietorship, where applicable) will each receive from:
          </p>

          <ul className="mb-4 list-outside list-disc pl-8">
            <li>
              OCBC Bank (or an OCBC Subsidiary) – a 2 year, interest-free term
              loan of up to SGD 200,000 (or MYR 600,000, or HKD 1,000,000, or
              IDR 2,000,000,000, as set out in the terms and conditions);
            </li>

            <li>
              The Business Times - Media publicity in print, digital, social
              media for Singapore and the region; and
            </li>

            <li>
              RSM - &quot;Consulting Package for Growing Businesses” worth
              SGD$15,000.
            </li>
          </ul>

          <p>
            <strong>Most Promising Sustainability Startup Award</strong>
          </p>

          <p>
            Recognises emerging sustainability enterprises with a strong startup
            spirit. These are startups that have developed a unique and
            commercially viable idea, which has the potential to be sustained in
            the long run.
          </p>

          <p className="mb-0">Winner(s) will receive from:</p>
          <ul className="mb-6 list-outside list-disc pl-8">
            <li>
              The Business Times - Media publicity in print, digital, social
              media for Singapore and the region.
            </li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default WinnersCountSection;
